<template>
    <div>
 
        <div class="bg-white rounded-md shadow overflow-hidden max-w-full">
            <form @submit.prevent="store">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                  <text-input type="hidden" v-model="form.parent_type_id" :error="form.errors.parent_type_id" />  
                  <text-input v-model="form.name" :error="form.errors.name" class="pr-6 pb-8 w-full w-full" :label="__('Name')" />
                  <select-input-filter :placeholder="__('Type equipament')" :onInput="doFilter" :items="TypeEquipament" v-model="form.type_id" :error="form.errors.type_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Type equipament')">
                  </select-input-filter>
                  <text-input v-model="form.serie" :placeholder="__('# Serie')" :error="form.errors.serie" class="pr-6 pb-8 w-full lg:w-1/4" :label="__('# Serie')" />

                  <select-input-filter :placeholder="__('Locations')" :onInput="doFilterLocation" :items="LocationList" v-model="form.location_id" :error="form.errors.location_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Location')">
                  </select-input-filter>

                  <select-input-filter :placeholder="__('Status Equipament')" :onInput="doFilterStatusEquipament" :items="StatusEquipamentList" v-model="form.status_id" :error="form.errors.status_id"
                                class="pr-6 pb-8 w-full lg:w-1/4" :label="__('Status Equipament')">
                  </select-input-filter>

                  <text-input type="date" v-model="form.buys" :placeholder="__('# Serie')" :error="form.errors.buys" class="pr-6 pb-8 w-full lg:w-1/6" :label="__('Date Buys')" />
                  <text-input v-model="form.supplier" :placeholder="__('Supplier')" :error="form.errors.serie" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Supplier')" />

                  <select-input-filter :placeholder="__('Responsible')" :onInput="doFilterResponsible" :items="ResponsibleList" v-model="form.responsible" :error="form.errors.responsible"
                                class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Responsible')">
                  </select-input-filter>

                  <select-input :onChange="loadCategories" v-model="form.department_id" :error="form.errors.department_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Department')">
                        <option :value="null" />
                        <option v-for="s in Departments" :key="s.id" :value="s.id">{{ s.name }}</option>
                  </select-input>
                  
                  <select-input  v-model="form.category_id" :error="form.errors.category_id" class="pr-6 pb-8 w-full lg:w-1/3" :label="__('Category')" :required="true">
                        <option :value="null" />
                        <option v-for="s in Categories" :key="s.id" :value="s.id">{{ s.name }}</option>
                    </select-input>


                  <TextareaInput v-model="form.notes" class="pr-6 pb-8 w-full" :label="__('Notes')"></TextareaInput>
                  
                </div>

                <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center">
                    <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Create') }}
                        {{ __('Equipament') }}</loading-button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectInputFilter from '@/Shared/SelectInputFilter'
import TextareaInput from '@/Shared/TextareaInput'
import LoadingButton from '@/Shared/LoadingButton'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import UploadAdapter from '@/Shared/UploadAdapter';

export default {
    metaInfo: { title: 'Create Ticket' },
    components: {
        LoadingButton,
        SelectInput,
        SelectInputFilter,
        TextInput,
        TextareaInput,
        Link,
        Icon,
    },
    layout: Layout,
    props: {
        TypeEquipament:Object,
        LocationList : Object,
        StatusEquipamentList :  Object,
        ResponsibleList : Object,
        Departments : Object,
        Categories : Object
    },
    remember: false,
    data() {
        return {
             
            form: this.$inertia.form({
                name: null,
                type_id : null,
                serie : null,
                location_id : null,
                buys : null,
                status_id : null,
                supplier : null,
                responsible : null,
                notes : null,
                department_id: null,
                category_id : null,
                parent_type_id : 1
            }),
        }
    },
    created() {
        
    },
    methods: {
        setDefaultValue(arr, key, value){
            const find = arr.find(i=>i.name.match(new RegExp(value + ".*")))
            if(find){
                this.form[key] = find['id']
            }
        },
        doFilter(e){
            this.axios.get(this.route('filter.lists.typeequipament', {search: e.target.value})).then((res)=>{
                this.TypeEquipament.splice(0, this.TypeEquipament.length, ...res.data);
            })
        },
        doFilterLocation(e){
            this.axios.get(this.route('filter.lists.locationlist', {search: e.target.value})).then((res)=>{
                this.LocationList.splice(0, this.LocationList.length, ...res.data);
            })
        },
        doFilterStatusEquipament(e){
            this.axios.get(this.route('filter.lists.statusequipament', {search: e.target.value})).then((res)=>{
                this.StatusEquipamentList.splice(0, this.StatusEquipamentList.length, ...res.data);
            })
        },
        doFilterResponsible(e){
            this.axios.get(this.route('filter.lists.statusequipament', {search: e.target.value})).then((res)=>{
                this.StatusEquipamentList.splice(0, this.StatusEquipamentList.length, ...res.data);
            })
        },
        store() {
            this.form.post(this.route('equipament.store'))
        },
        loadCategories(e){ 
            this.axios.get(this.route('equipament.ajax', {opc: 'categories', department_id: e.target.value})).then((res)=>{
                this.Categories.splice(0, this.Categories.length, ...res.data);
            })
        }      
    },
}
</script>
